module.exports = __webpack_public_path__ + "static/media/08 - Shipping B.dbc57fc4.png";